import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FullTableAccordion, ToastScreen } from 'components';
import {
  ACTION_TYPE_GET_BATCHES,
  ACTION_TYPE_UN_PAY_CARRIER_PAYMENT_BATCH,
  batchStatusesEnum,
  paidPayableBatchesBody,
  paidPayableBatchesHead,
} from './constants';
import { PaidPayableBatchesDetails } from './paidPayableBatchesDetails';
import { loadActions, carrierActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions } from 'store';
import { CustomDeleteModal } from 'fragments';
import { FindError, useModal } from 'utils';


export const PaidPayableBatches = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { batchesList } = useSelector((state) => ({
    batchesList: state.loads.batchesList,
  }));
  const beckErrorUnPay = FindError(ACTION_TYPE_UN_PAY_CARRIER_PAYMENT_BATCH);
  const info = history?.location?.state;


  useEffect(() => {
    if (beckErrorUnPay?.[0]?.error) {
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE_UN_PAY_CARRIER_PAYMENT_BATCH));
      toast(
        <ToastScreen
          type={'error'}
          text={beckErrorUnPay?.[0]?.error}
        />,
      );
    }
  }, [beckErrorUnPay]);

  const renderParams = () => {
    const filteredInfo = {
      ...info,
      status: batchStatusesEnum.PAID,
    };
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 100;

    filteredInfo?.mcs ? filteredInfo.mcs = filteredInfo.mcs?.map((mc) => mc?.id) : delete filteredInfo?.mcs;
    filteredInfo?.offices ? filteredInfo.offices = filteredInfo.offices?.map((office) => office?.id) : delete filteredInfo?.offices;

    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    delete filteredInfo.viewType;
    return filteredInfo;
  };


  useEffect(() => {
    dispatch(loadActions.getBatches(renderParams()));
  }, [info]);

  // const handleUnPay = (item) => {
  //   open(
  //     <CustomDeleteModal
  //       afterSuccess={() => {
  //         dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_UN_PAY_CARRIER_PAYMENT_BATCH));
  //         dispatch(loadActions.getBatches(renderParams(), false));
  //         close();
  //       }}
  //       actionType={ACTION_TYPE_UN_PAY_CARRIER_PAYMENT_BATCH}
  //       text='Are you sure you want to unpay this batch?'
  //       handleDel={(e) => {
  //         e.stopPropagation();
  //         dispatch(carrierActions.unPayCarrierPaymentBatch(item?.id));
  //       }
  //       }
  //       modalText={'All Orders included in this batch will be marked as unpaid.'}
  //       cancelButton={'Unpay'}
  //       closeButton={'Go Back'}
  //     />);
  // };

  const changeBatchName = (id, value) => {
    if (value) {
      const updatedList = batchesList?.batches?.map((batch) => {
        if (batch?.id === id) {
          return {
            ...batch,
            name: value,
          };
        }

        return batch;
      });
      dispatch(loadActions.editBatchList({ batches: updatedList, count: batchesList?.count }));
      dispatch(loadActions.editBatchTable(id, { name: value }));
    }
  };

  return (
    <div>
      <FullTableAccordion
        head={paidPayableBatchesHead}
        body={paidPayableBatchesBody({ changeBatchName })}
        renderDetails={(item) => <PaidPayableBatchesDetails batch={item} />}
        loadingType={ACTION_TYPE_GET_BATCHES}
        list={batchesList?.batches}
        listCount={batchesList?.count}
        fixHeight={batchesList?.count ? '75vh' : '82vh'}
        noText={'Pending Batches'}
      />
    </div>
  );
};

